const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  device: state => state.app.device,
  theme: state => state.app.theme,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  status: state => state.user.status,
  roles: state => state.user.roles,
  setting: state => state.user.setting,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  errorLogs: state => state.errorLog.logs,
  menus: state => state.permission.menus,
  userInfo: state => state.user.userInfo,
  menuId: state => state.app.menuId,
  systemConfig_info: state => state.systemConfig.info,
  systemConfig_name: state => state.systemConfig.name,
  systemConfig_title: state => state.systemConfig.title,
  systemConfig_logo: state => state.systemConfig.logo,
  systemConfig_IM: state => state.systemConfig.IM,
  systemConfig_asset: state => state.systemConfig.asset,
  systemConfig_fileView: state => state.systemConfig.FileView,
  recodeMenu: state => state.permission.recodeMenu
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js